// extracted by mini-css-extract-plugin
export default {"tabContainer":"labeltypetabs_tabContainer__h+b3M","tabBtn":"labeltypetabs_tabBtn__OrxpC","active":"labeltypetabs_active__KOT6s"};